export const LOCAL_STORAGE_NAMESPACE = 'CdcMarket.'

export const SESSION_STORAGE_NAMESPACE = 'CdcMarket.'

export const REDIRECT_URL_PARAM_KEY = 'redirect'

export const NOT_APPLICABLE = 'N/A'

export const HELP_CENTER_LINK = 'https://help.crypto.com/en'

export const HELP_CENTER_LINKS_MAP = {
  PAY_STRING: `${HELP_CENTER_LINK}/articles/4424992-paystring-how-does-it-work`,
  PASSKEY: `${HELP_CENTER_LINK}/articles/9196438-passkeys`,
  PRIME_DEPOSIT_BONUS: `${HELP_CENTER_LINK}/articles/8850742-crypto-com-prime-deposit-bonus`,
  TWO_FA: `${HELP_CENTER_LINK}/articles/3208595-how-to-set-up-your-crypto-com-app-2fa`,
  SPORTS_EVENTS_HOW_IT_WORKS: `${HELP_CENTER_LINK}/articles/10208780-sports-event-contracts`,
  SPORTS_EVENTS_SLIPPAGE: `${HELP_CENTER_LINK}/articles/10208780-sports-event-trading#h_9bb3e89a5f`,
  HOW_TO_CHOOSE_NETWORK: `${HELP_CENTER_LINK}/articles/5529369-how-to-choose-a-network-when-depositing-withdrawing-crypto`,
  AVOIDING_DIGITAL_CURRENCY_SCAMS: `${HELP_CENTER_LINK}/articles/6484926-avoiding-digital-currency-scams`,
  PAYPAL_DEPOSIT_HOW_IT_WORKS: `${HELP_CENTER_LINK}/articles/11087181-usd-deposits-via-paypal`,
}

export const BASE_PATH = '/price'
